import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.messaging.chat.messagingId;

const getSelectedMessagingId = createSelector(
  getData,
  messagingId => messagingId
);

export default getSelectedMessagingId;



// WEBPACK FOOTER //
// ./src/_selectors/messagingSelectors/getSelectedMessagingId.js